import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule, Type } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatCommonModule } from "@obg/mat.ui.common";
import { DialogLayoutModule, MatCoreModule } from "@obg/mat.ui.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { ComponentFactoryService, ImageContentDirectiveModule } from "@obg/ngx.ui.core";

import { CustomerVerificationDialogContainer } from "./customer-verification-dialog.container";
import { CustomerVerificationStepContainer } from "./customer-verification-step.container";
import { CustomerVerificationContainer } from "./customer-verification.container";

const DIRECTIVES: Type<unknown>[] = [
	CustomerVerificationDialogContainer,
	CustomerVerificationContainer,
	CustomerVerificationStepContainer,
];

@NgModule({
	imports: [
		CommonModule,
		CoreContentModule,
		ImageContentDirectiveModule,
		MatButtonModule,
		MatCommonModule,
		MatCoreModule,
		MatDialogModule,
		DialogLayoutModule,
		MatCardModule,
		MatIconModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CustomerVerificationModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, CustomerVerificationDialogContainer);
	}
}
